

export class UserSelectAllOutputDataVehicleList implements IUserSelectAllOutputDataVehicleList {
    vehicle!: string;

    constructor(data?: IUserSelectAllOutputDataVehicleList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle = _data["vehicle"];
        }
    }

    static fromJS(data: any): UserSelectAllOutputDataVehicleList {
        data = typeof data === 'object' ? data : {};
        let result = new UserSelectAllOutputDataVehicleList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle"] = this.vehicle;
        return data; 
    }
}

export interface IUserSelectAllOutputDataVehicleList {
    vehicle: string;
}

